import pageheader from "../../pageheader";
import CustomerScopeNotice from "@/components/Common/CustomerScopeNotice";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import telematicsService from "../../../api/telematics.service";
import rules from "../../../utils/rules";
export default {
  name: "access-control-operators",
  components: { pageheader, CustomerScopeNotice },
  data() {
    return {
      input: {},
      confirmdialoggroup: false,
      confirmdialogoperator: false,
      selectedgroup: {},
      isdeleteoperator: false,
      selectedoperator: {},
      accessControlList: [],
      selectedAccessControl: null,
      isLoaderAccessControl: false,
      searchAccessControl: null,
      selectedCompanyName: "",
      tabType: "",
      isGlobal: false,
      tabModel: 0,
      groupSearch: "",
      isGetGroupAccessKeys: false,
      groupAccessCodesList: [],
      accessControlSearch: "",
      accessControlAccessCodesList: [],
      isGetAccessControlAccessKeys: false,
      accessControlCodeDialog: false,
      groupHeaders: [
        { text: "Group Name", value: "name" },
        { text: "Description", value: "description" },
        { text: "Equipment", value: "machinesCount" },
        { text: "Created By", value: "createdBy" },

        { text: "Actions", value: "action" },
      ],
      extendedInfoId: "",
      accessControlHeaders: [
        { text: "First Name", value: "firstName" },
        { text: "Last name", value: "lastName" },

        { text: "Phone Number", value: "phoneNumber" },
        { text: "Email", value: "email" },
        { text: "Equipment", value: "machinesCount" },
        { text: "Actions", value: "action" },
      ],
      typeOfOperation: "",
      isdeletegroup: false,
      controlCodeFormValid: true,
      rules: rules,
      defaultAccessControlCodeId: "",
      controlCodeName: "",
      controlCodeSerialNumber: "",
      keyValidList: [
        { name: "30sec", value: "30sec" },
        { name: "60sec", value: "60sec" },
        { name: "90sec", value: "90sec" },
      ],
      selectedKeyValid: "",
      keyExpireList: [
        { name: "0sec", value: "0sec" },
        { name: "15sec", value: "15sec" },
        { name: "30sec", value: "30sec" },
        { name: "60sec", value: "60sec" },
        { name: "2min", value: "2min" },
        { name: "5min", value: "5min" },
        { name: "10min", value: "10min" },
        { name: "15min", value: "15min" },
        { name: "30min", value: "30min" },
        { name: "1hour", value: "1hour" },
        { name: "2hours", value: "2hours" },
        { name: "4hours", value: "4hours" },
        { name: "8hours", value: "8hours" },
        { name: "16hours", value: "16hours" },
      ],
      selectedKeyExpire: "",
      controlCodeNotes: "",
      isBtnSubmit: false,
      unitIdsList: [],
    };
  },
  created() {
    this.tabModel = this.accessTabsVal;
  },
  computed: {
    ...mapGetters(["roles", "companyIdDropdown", "accessTabsVal"]),
  },
  mounted() {
    this.input = utils.getInputContent("accessControlOperators", this.roles);
    if (this.tabModel == 0) {
      this.getAccessControlOperatorsList();
    } else {
      this.getGroupControlOperatorsList();
    }
  },
  watch: {
    // BE-1121: the screen is scoped to the toolbar customer, so it has to follow
    // it -- switching customers used to leave the previous one's rows on screen.
    companyIdDropdown() {
      this.accessControlAccessCodesList = [];
      this.groupAccessCodesList = [];
      if (this.tabModel == 0) {
        this.getAccessControlOperatorsList();
      } else {
        this.getGroupControlOperatorsList();
      }
    },
    searchAccessControl(val) {
      //check entered text is not undefined and enter search text is multiples of 2 characters
      if (val != undefined && val != "All" && val.length % 2 == 0) {
        this.searchAccessControls(val);
      }
    },
  },
  methods: {
    async searchAccessControls(value) {
      try {
        this.isLoaderAccessControl = true;
        const response = await telematicsService.searchBasicAccessControls(
          value,
        );
        if (response.isSuccess) {
          let finaldata = response.data.filter((e) => e.name !== "");
          this.accessControlList = finaldata.map((item) => {
            return {
              name: item.name ? item.name : "",
              id: String(item.id) ? String(item.id) : "",
            };
          });
          this.isLoaderAccessControl = false;
        } else {
          this.isLoaderAccessControl = false;
        }
      } catch (err) {
        this.isLoaderAccessControl = false;
        console.log(err);
      }
    },
    tabChange() {
      this.$store.dispatch("setAccessTabVal", Number(this.tabModel));
      this.tabModel = this.accessTabsVal;
      this.groupSearch = "";
      this.accessControlSearch = "";
    },
    clearGroupSearch() {
      this.groupSearch = "";
    },
    clearAccessControlSearch() {
      this.accessControlSearch = "";
    },
    confirmDeleteGroup(item) {
      this.confirmdialoggroup = true;
      this.selectedgroup = item;
    },
    async deleteGroupControl() {
      try {
        this.isdeletegroup = true;
        var response;
        response = await telematicsService.deleteGroupControl(
          this.selectedgroup.id,
        );

        if (response.isSuccess) {
          this.isdeletegroup = false;
          this.$toast.success("Operator Group deleted successfully");
          this.getGroupControlOperatorsList();
          this.confirmdialoggroup = false;
          this.selectedgroup = {};
        } else {
          this.isdeletegroup = false;
          this.$toast.success(response.systemMessage);
        }
      } catch (err) {
        this.isdeletegroup = false;
        this.$toast.error("Unable to delete Operator Group" + err);
      }
    },

    confirmDeleteOperator(item) {
      this.confirmdialogoperator = true;
      this.selectedoperator = item;
      this.selectedoperator.name = item.firstName + " " + item.lastName;
    },
    async deleteOperatorControl() {
      try {
        this.isdeleteoperator = true;
        var response;
        response = await telematicsService.deleteOperatorControl(
          this.selectedoperator.id,
        );

        if (response.isSuccess) {
          this.isdeleteoperator = false;
          this.$toast.success("Operator deleted successfully");
          this.getAccessControlOperatorsList();
          this.confirmdialogoperator = false;
          this.selectedoperator = {};
        } else {
          this.isdeleteoperator = false;
          this.$toast.success(response.systemMessage);
        }
      } catch (err) {
        this.isdeleteoperator = false;
        this.$toast.error("Unable to delete Operator" + err);
      }
    },
    async getGroupControlOperatorsList() {
      this.tabType = "group";
      this.isGetGroupAccessKeys = true;
      this.groupAccessCodesList = [];
      try {
        let response = await telematicsService.getGroupControlOperatorsList();
        if (response && response.data) {
          this.isGetGroupAccessKeys = false;
          this.groupAccessCodesList = response.data;
        } else {
          this.isGetGroupAccessKeys = false;
          this.groupAccessCodesList = [];
        }
      } catch (err) {
        this.isGetGroupAccessKeys = false;
        console.log(err);
      }
    },
    async getAccessControlOperatorsList() {
      this.tabType = "access";

      // Nothing to fetch until a customer is chosen; CustomerScopeNotice says so.
      if (this.companyIdDropdown) {
        this.isGetAccessControlAccessKeys = true;
        this.accessControlAccessCodesList = [];
        try {
          let response = await telematicsService.getOperatorsList(
            this.companyIdDropdown,
          );
          if (response && response.data) {
            this.isGetAccessControlAccessKeys = false;
            this.accessControlAccessCodesList = response.data;
          } else {
            this.isGetAccessControlAccessKeys = false;
          }
        } catch (err) {
          this.isGetAccessControlAccessKeys = false;
          console.log(err);
        }
      }
    },
    openEditAccessControlDialog(item) {
      this.clearControlCodeFields();
      this.accessControlCodeDialog = true;
      this.typeOfOperation = "Update";
      this.defaultAccessControlCodeId = item.id;
      (this.extendedInfoId = item.extendedInfoId),
        (this.controlCodeName = item.name);
      this.selectedCompanyName = item.companyName;
      if (this.tabType == "group") {
        this.searchAccessControls(item.accessControlName);
        this.selectedAccessControl = {
          id: item.accessControlId,
          name: item.accessControlName,
        };
      } else {
        this.selectedAccessControl = null;
      }
      (this.isGlobal = item.isGlobal != undefined ? item.isGlobal : false),
        (this.controlCodeSerialNumber = item.serialNumber);
      this.selectedKeyExpire = item.keyExpire;
      this.selectedKeyValid = item.keyValid;
      this.controlCodeNotes = item.note;
      this.unitIdsList = item.equipments;
    },
    pushEditRoute(routeName, item) {
      this.$router.push({
        name: routeName,
        params: { id: item.id },
        query: {
          type: "edit",
        },
      });
    },
    editGroup(item) {
      this.pushEditRoute("Edit Group Control Operators Management", item);
    },
    editAccess(item) {
      this.pushEditRoute("Edit Access Control Operators Management", item);
    },
    cancelAccessControlDialog() {
      this.accessControlCodeDialog = false;
      this.typeOfOperation = "";
      this.clearControlCodeFields();
    },
    // Keys shared by every create/update payload, in their original order so
    // the serialized body is unchanged when spread between the leading
    // id/ownerType key and the trailing owner-specific keys.
    controlCodeFields() {
      return {
        name: this.controlCodeName,
        serialNumber: this.controlCodeSerialNumber,
        keyValid: this.selectedKeyValid,
        keyExpire: this.selectedKeyExpire,
        note: this.controlCodeNotes,
        isGlobal: this.isGlobal,
      };
    },
    selectedAccessControlFields() {
      return {
        accessControlName:
          this.selectedAccessControl != null
            ? this.selectedAccessControl["name"]
            : "",
        accessControlId:
          this.selectedAccessControl != null
            ? String(this.selectedAccessControl["id"])
            : "",
      };
    },
    clearControlCodeFields() {
      this.controlCodeName = "";
      this.selectedCompanyName = "";
      this.selectedAccessControl = null;
      this.controlCodeSerialNumber = "";
      this.selectedKeyExpire = "";
      this.selectedKeyValid = "";
      this.controlCodeNotes = "";
      this.unitIdsList = [];
    },
    async updateAccessControlCode() {
      this.isBtnSubmit = true;
      let extendedInfoId = this.extendedInfoId;
      let accessControlId, ownerType;
      if (this.tabModel == 0) {
        accessControlId = "";
        ownerType = "1";
      } else {
        accessControlId = this.companyIdDropdown;
        ownerType = "2";
      }

      let payload1 = {
        id: this.defaultAccessControlCodeId,
        ...this.controlCodeFields(),
        companyName: this.selectedCompanyName,
        ...this.selectedAccessControlFields(),
      };
      let payload2 = {
        id: this.defaultAccessControlCodeId,
        ...this.controlCodeFields(),
        accessControlId: String(this.companyIdDropdown),
      };
      let payload;

      if (this.tabType == "group") {
        payload = payload1;
      } else if (this.tabType == "access") {
        payload = payload2;
      }
      try {
        let response = await telematicsService.updateAccessControlCodeDetails(
          extendedInfoId,
          accessControlId,
          ownerType,
          payload,
        );
        if (response.isSuccess) {
          this.$toast.success(
            "Access control code has been updated successfully.",
          );
          this.isBtnSubmit = false;
          this.cancelAccessControlDialog();
          if (this.tabModel == 0) {
            this.getAccessControlOperatorsList();
          } else {
            this.getGroupControlOperatorsList();
          }
        } else {
          this.$toast.error("Failed to update the access control code");
          this.isBtnSubmit = false;
        }
      } catch (err) {
        console.log(err);
        this.$toast.error("Unable to update the access control code" + err);
        this.isBtnSubmit = false;
      }
    },
    openCreateAccessControlDialog() {
      this.$router.push("/access-control/operators/add");
    },
    openCreateGroupControlDialog() {
      this.$router.push("/access-control/operator-groups/add");
    },
    //Post Call Create Access Control Code
    async createAccessControlCode() {
      this.isBtnSubmit = true;
      let ownerType;
      if (this.tabModel == 0) {
        ownerType = "1";
      } else {
        ownerType = "2";
      }

      let payload1 = {
        ownerType: ownerType,
        ...this.controlCodeFields(),
        companyName: this.selectedCompanyName,
        ...this.selectedAccessControlFields(),
      };
      let payload2 = {
        ownerType: ownerType,
        ...this.controlCodeFields(),
        accessControlId: String(this.companyIdDropdown),
      };
      let payload;

      if (this.tabType == "group") {
        payload = payload1;
      } else if (this.tabType == "access") {
        payload = payload2;
      }
      try {
        let response = await telematicsService.createAccessControlCode(payload);
        if (response.isSuccess) {
          this.$toast.success(
            "Access control code has been created successfully.",
          );
          this.isBtnSubmit = false;
          this.cancelAccessControlDialog();

          if (this.tabModel == 0) {
            this.getGroupControlOperatorsList();
          } else {
            this.getAccessControlOperatorsList();
          }
        } else {
          this.$toast.error(
            "Failed to create the access control code. please try again after sometime.",
          );
          this.isBtnSubmit = false;
        }
      } catch (err) {
        console.log(err);
        this.$toast.error("Unable to create the access control code" + err);
        this.isBtnSubmit = false;
      }
    },
  },
};
